<template>
  <div class="fb fb-col fb-main-start font-34 height" ref="flexw">
    <div class="page-wapper fb fb-col">
      <div class="page-content item-flex-1 fb fb-col">
        <div
          class="p-16-0 bg-FFFFFF p-0-16 bb-8 fb fb-main-between fb-cross-center font-28 mb-12"
          v-if="checkedScheduleData.type === 'teacher'"
        >
          <div class="max-w-150 text-ellipsis text-bold-600"
            >{{ checkedScheduleData.applicantTeacherName }}的课表</div
          >
          <div v-if="!checkedScheduleData.isDisabled">
            已选 <span class="c-006AFE">{{ selectedCourse.length }}</span> 节
          </div>
        </div>
        <div
          class="p-16-0 bg-FFFFFF p-0-16 bb-8 fb fb-main-between fb-cross-center font-28 mb-12"
          v-else
        >
          <div>
            {{ computedSectionText }}
          </div>
          <div class="max-w-150 text-ellipsis">
            {{ checkedScheduleData.className }}
          </div>
        </div>
        <md-tabbar
          v-model="filter.weekId"
          class="bb"
          v-if="filter.weekId && weekList.length"
          :fixed="false"
          indicatorColor="#171A1D"
        >
          <md-tabbar-item
            v-for="item in weekList"
            :key="item.weekId"
            :name="item.weekId"
          >
            {{ item.name }}
          </md-tabbar-item>
        </md-tabbar>
        <div class="timetable c-171A1D item-flex-1 mt-12">
          <div
            class="timetable-day ff-medium font-26 fb c-171A1D-60"
            v-show="timetable.length"
          >
            <div class="week-index"><div></div></div>
            <div
              class="week-day text-center"
              :key="key"
              v-for="(v, key) in WEEK_TEXT"
              >周{{ v }}</div
            >
          </div>
          <div class="timetable-data item-flex-1">
            <div
              class="data-row fb font-26 ff-regular"
              v-for="(row, index) in timetable"
              :key="index"
            >
              <div
                class="data-index fb fb-cross-center fb-main-center c-171A1D-60"
                ><div class="row-index">{{ index + 1 }}</div></div
              >
              <div
                class="data-item fb fb-main-center fb-col pointer"
                v-for="(course, cdx) in row"
                :key="cdx"
                :class="[
                  {
                    substituteType1: course.substituteType === 1
                  },
                  {
                    substituteType2: course.substituteType === 2
                  },
                  course.activeClass
                ]"
                @click="handlerCheckedCourse(course)"
              >
                <div
                  class="classname ellipsis-l2 mb-4"
                  v-if="checkedScheduleData.type === 'teacher'"
                  :class="{
                    'text-bold-600': course.activeClass !== 'disabled'
                  }"
                  >{{ (course.classNames || []).join('、') }}</div
                >
                <div
                  class="course-name"
                  :class="{
                    'text-bold-600':
                      course.activeClass !== 'disabled' &&
                      checkedScheduleData.type === 'teacher'
                  }"
                  >{{ filterName(course.courseName, 6) }}</div
                >
                <div
                  class="teacher-name mt-4"
                  v-if="checkedScheduleData.type === 'classSchedule'"
                  >{{ course.teacherName | getTeacherName(course.teacherName) }}
                </div>
              </div>
            </div>
          </div>
          <common-no-data
            class="no-record timetable c-171A1D item-flex-1 mt-12"
            :style="{ height: `${height}px` }"
            v-show="!timetable.length"
          >
            <div class="no-clearplate"></div>
            <p class="pb-24 font-28 no-text c-171A1D">暂无课程</p>
          </common-no-data>
        </div>
      </div>
    </div>
    <template v-if="!checkedScheduleData.isDisabled">
      <div class="footer bg-FFFFFF p-0-16 h-auto pb-16" v-if="conflictName">
        <div class="font-30 c-171A1D-60 p-12-0">
          <i class="iconfont">&#xe680;</i>
          {{ conflictName }}老师的课程存在冲突。</div
        >
        <div class="font-26 fb fb-main-start fb-cross-center bt-8">
          <common-button @click="handlerClose">添加</common-button>
        </div>
      </div>
      <div class="footer font-26 fb fb-main-start fb-cross-center bt-8" v-else>
        <common-button @click="handlerClose">添加</common-button>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonNoData from './commonNoData'
import commonButton from './commonButton'
import API from '@/api'
import { NUM_TEXT, WEEK_TEXT } from '@/utils/constUtils'
import { filterName } from '@/utils/comUtils'
export default {
  mixins: [mixin],
  components: {
    commonNoData,
    commonButton
  },
  props: {
    checkedScheduleData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      filterName,
      // 调代课ID 管理员
      scheduleSubstituteId: this.$route.query.scheduleSubstituteId || '',
      NUM_TEXT,
      WEEK_TEXT,
      height: 0,
      timetable: [],
      filter: {
        gradeDingId: null,
        classDingId: null,
        weekId: 1,
        startDay: null,
        endDay: null,
        weekStr: null,
        className: null,
        teacherDingId: null,
        teacherName: null
      },
      currentTarget: {},
      weekList: [],
      selectedCourse: [],
      conflictName: '',
      showLoading: null
    }
  },
  computed: {
    computedSectionText() {
      const data = this.checkedScheduleData
      return `周${data.weekDay ? NUM_TEXT[data.weekDay] : '日'}  第${
        NUM_TEXT[data.sectionNumber]
      }节 ${filterName(data.courseName, 6)}`
    }
  },
  filters: {
    getTeacherName(name) {
      return name ? filterName(name) : '-'
    }
  },
  watch: {
    'filter.weekId'(val) {
      this.timetable = []
      this.showLoading.show()
      let target = this.weekList.filter(v => +v.weekId === +val)
      this.filter.startDay = target[0].startDay
      this.filter.endDay = target[0].endDay
      this.getSchedule()
    }
  },
  created() {
    this.showLoading = this.$Toast({
      type: 'loading',
      duration: 9000,
      content: '加载中···'
    })
    this.init()
  },
  methods: {
    getSchedule() {
      const isClassSchedule = this.checkedScheduleData.isEditClassTransfer // true老师课表  false 班级课表
      const query = this.checkedScheduleData
      const params = {
        ...this.commonTerm,
        ...this.commonParams,
        startDimDay: this.filter.startDay,
        endDimDay: this.filter.endDay,
        selectSection: {
          courseId: query.courseId,
          courseName: query.courseName,
          dimDay: query.dimDay,
          sectionNumber: query.sectionNumber,
          teacherDingId: query.applicantTeacherDingId,
          teacherName: query.applicantTeacherName,
          timetableSectionId: query.timetableSectionId,
          weekDay: query.weekDay
        }
      }
      if (isClassSchedule) {
        params.classDingId = query.classDingId
      } else {
        params.teacherDingId = query.applicantTeacherDingId
        if (query.batchChoose) {
          delete params.selectSection
        }
      }

      API[
        isClassSchedule ? 'getClassSchedule' : 'substituteGetTeacherSchedule'
      ](params)
        .then(res => {
          if (res.result) {
            this.$Toast({
              type: 'fail',
              content: res.message
            }).show()
            return
          }
          const section = isClassSchedule
            ? res.timetableClass.sectionNumberEnd
            : res.sectionNumber

          const data =
            res[
              isClassSchedule ? 'scheduleClassDetailsVoList' : 'teacherDetails'
            ]
          let timetable = new Array(section)
            .fill(null)
            .map(
              item =>
                (item = new Array(7).fill(null).map(course => (course = {})))
            )
          data.forEach(item => {
            let row = timetable[item.sectionNumber - 1]
            let isDisabled = []
            if (this.checkedScheduleData.selected) {
              isDisabled = this.checkedScheduleData.selected.filter(v => {
                return (
                  v.dimDay === item.dimDay &&
                  v.sectionNumber === item.sectionNumber &&
                  v.teacherDingId === item.teacherDingId
                )
              })
            }
            let activeClass = ''
            if (
              +query.dimDay === +item.dimDay &&
              +query.sectionNumber === +item.sectionNumber
            ) {
              activeClass = 'origin'
            } else if (item.unselectReasonType === 3 && item.courseName) {
              activeClass = 'unSelectReasonType'
            } else if (
              (isDisabled.length || item.unselectReasonType) &&
              item.courseName
            ) {
              activeClass = 'disabled'
            }
            // 之前保存的，加回去
            let isChecked = this.selectedCourse.filter(
              v =>
                v.dimDay === item.dimDay &&
                v.sectionNumber === item.sectionNumber
            )
            if (isChecked.length) {
              activeClass = isChecked[0].activeClass
            }
            row[!item.weekDay ? 6 : item.weekDay - 1] = {
              ...item,
              activeClass,
              originClass: activeClass
            }
          })
          this.timetable = timetable
          this.$forceUpdate()
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.showLoading && this.showLoading.hide()
        })
    },
    init() {
      this.fetchWeekList()
      this.$nextTick(() => {
        this.height =
          document.body.clientHeight - this.$refs.flexw.clientHeight - 12
      })
    },
    handlerClose() {
      // 区分老师课表和班级课表
      if (this.checkedScheduleData === 'classSchedule') {
        this.$emit('handlerClose', this.currentTarget)
      } else {
        this.$emit('handlerClose', this.selectedCourse)
      }
    },
    handlerCheckedCourse(row) {
      // 禁止选择无课程或者特定条件的
      // unselectReasonType 1:已过期, 2:自己任教课程, 3:存在冲突, 4:待安排调代课, 5:已安排调代课
      const that = this
      let isToggle = (this.selectedCourse || []).findIndex(
        v =>
          v.sectionNumber === row.sectionNumber &&
          v.weekDay === row.weekDay &&
          v.dimDay === row.dimDay
      )
      if (
        !row.courseName ||
        row.activeClass === 'disabled' ||
        this.checkedScheduleData.isDisabled ||
        [1, 2, 4, 5].includes(row.unselectReasonType)
      ) {
      } else if (row.activeClass === 'active') {
        row.activeClass = row.originClass
        this.selectedCourse.splice(isToggle, 1)
        if (row.unselectReasonType === 3) {
          this.conflictName = ''
        }
      } else if (this.checkedScheduleData.edit) {
        // 特殊情况二次弹窗提示
        if (row.unselectReasonType === 3) {
          this.$Dialog({
            type: 'confirm',
            title: '课程冲突',
            cancelBtn: {
              color: '#006afe',
              text: '取消'
            },
            confirmBtn: {
              color: '#006afe',
              text: '确认'
            },
            content: `<div class="text-left">${row.conflictTeacherName}老师的课程存在冲突，确认选择？</div>`,
            onConfirm() {
              that.timetable.map(row => {
                row.map(item => {
                  item.activeClass = item.originClass
                })
              })
              row.activeClass = 'active'
              that.conflictName = row.conflictTeacherName
              that.selectedCourse = [row]
            }
          }).show()
        } else {
          this.timetable.map(row => {
            row.map(item => {
              item.activeClass = item.originClass
            })
          })
          row.activeClass = 'active'
          this.conflictName = ''
          this.selectedCourse = [row]
        }
      } else {
        row.activeClass = 'active'
        this.selectedCourse.push(row)
      }
    },
    fetchWeekList() {
      return new Promise((resolve, reject) => {
        const { schoolYear, termOrder, termEndDimDay, termStartDimDay } =
          this.$store.getters.semesterSetting
        API.getYearTeachWeek({
          campusId: this.campusId,
          operUserRoleTypes: `${this.currentRole}`,
          schoolYear
        })
          .then(res => {
            // 筛选当前学期的教学周
            const { schoolTermTeachWeekRespList } = (res || []).filter(
              item => item.schoolTermOrder === termOrder
            )[0]
            this.weekList = schoolTermTeachWeekRespList.reduce(
              (list, item) =>
                list.concat({
                  weekId: item.teachWeekId,
                  startDay: item.teachWeekStartDimDay,
                  endDay: item.teachWeekEndDimDay,
                  name: `${item.teachWeekDesc}`
                }),
              []
            )
            // 获取当前对应周信息
            const day = +this.checkedScheduleData.dimDay
            let matchedWeek = null
            // 当前日期不在当前学年学期的开始结束范围内 如果小于开始日期按照第一周 如果大于最后一周就按照最后一周
            if (day < termStartDimDay) {
              matchedWeek = this.weekList[0]
            } else if (day > termEndDimDay) {
              matchedWeek = this.weekList[this.weekList.length - 1]
            } else {
              matchedWeek = this.weekList.filter(
                item => item.startDay <= day && item.endDay >= day
              )[0]
            }
            const { weekId, startDay, endDay, name } = matchedWeek
            this.filter = {
              ...this.filter,
              weekId,
              startDay,
              endDay,
              weekStr: name
            }
            if (weekId === 1) {
              let target = this.weekList.filter(v => +v.weekId === +weekId)
              this.filter.startDay = target[0].startDay
              this.filter.endDay = target[0].endDay
              this.getSchedule()
            }
            resolve()
          })
          .catch(err => {
            console.log(`err`, err)
            reject(err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wapper {
  .page-content {
    position: relative;
    overflow: hidden;
    .timetable {
      position: relative;
      background: #fff;
      overflow: auto;
      -webkit-overflow-scrolling: auto;
      padding-bottom: 70px;
      &::-webkit-scrollbar {
        display: none;
      }
      &.no-record {
        padding-bottom: 0;
      }
      .timetable-day {
        position: sticky;
        top: 0;
        z-index: 20;
        > div {
          background: #e1e1e6;
          border-right: 1px solid rgba(126, 134, 142, 0.16);
          &:last-child {
            border-right: none;
          }
        }
        .week-index {
          position: sticky;
          top: 0;
          left: 0;
          bottom: 0;
          z-index: 21;
          > div {
            width: 20px;
          }
        }
        .week-day {
          line-height: 1.2;
          padding: 12px 0;
          flex: 0 0 calc(20% - 4px);
          box-sizing: border-box;
        }
      }
      .timetable-data {
        .classname {
          line-height: 16px;
        }
        .data-row {
          text-align: center;
          position: relative;
          &:last-child {
            .data-item {
              border-bottom: 1px solid rgba(126, 134, 142, 0.16);
            }
          }
          > div {
            border-top: 1px solid rgba(126, 134, 142, 0.16);
            border-right: 1px solid rgba(126, 134, 142, 0.16);
            &:last-child {
              border-right: none;
            }
          }
          .data-index {
            background: #e1e1e6;
            position: sticky;
            left: 0;
            z-index: 19;
            .row-index {
              width: 20px;
            }
          }
          .data-item {
            line-height: 1.2;
            padding: 4px;
            height: 76px;
            background: #fff;
            flex: 0 0 calc(20% - 4px);
            box-sizing: border-box;
            > div {
              min-height: 19px;
              padding-top: 3px;
              &:last-child {
                color: rgba(23, 26, 29, 0.6);
              }
            }
            &.disabled {
              background: rgba(0, 0, 0, 0.08);
              cursor: not-allowed;
              .course-name {
                color: rgba(23, 26, 29, 0.4);
              }
              .teacher-name {
                color: rgba(23, 26, 29, 0.24);
              }
            }
            &.origin {
              background: rgba(0, 106, 254, 0.48);
              div {
                color: #fff;
              }
            }
            &.active {
              background: rgba(0, 176, 66, 0.48);
              div {
                color: #fff;
              }
            }
            &.unSelectReasonType {
              background: rgba(255, 82, 25, 0.12);
              // div {
              //   color: #fff;
              // }
            }
          }
        }
      }
    }
  }
  .no-record {
    .no-clearplate {
      width: 180px;
      height: 180px;
      background: url(~@/assets/images/no-course.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
}
.footer {
  z-index: 100;
  position: fixed;
}
.substituteType1 {
  position: relative;
  &::after {
    width: 20px;
    height: 20px;
    background: #006afe;
    border-radius: 0px 0px 16px 0px;
    content: '调';
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.substituteType2 {
  position: relative;
  &::after {
    width: 20px;
    height: 20px;
    background: #006afe;
    border-radius: 0px 0px 16px 0px;
    content: '代';
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
